__turbopack_context__.v({
  "description": "qtR-Xa_description",
  "icon": "qtR-Xa_icon",
  "sidebarTitle": "qtR-Xa_sidebarTitle",
  "sidebarWrapper": "qtR-Xa_sidebarWrapper" + " " + "qtR-Xa_wrapper",
  "title": "qtR-Xa_title",
  "titleWrapper": "qtR-Xa_titleWrapper",
  "wrapper": "qtR-Xa_wrapper",
});
